import { render } from "./SecondSectionKuhul.vue?vue&type=template&id=47a67cea&scoped=true"
import script from "./SecondSectionKuhul.vue?vue&type=script&lang=js"
export * from "./SecondSectionKuhul.vue?vue&type=script&lang=js"

import "./SecondSectionKuhul.vue?vue&type=style&index=0&id=47a67cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a67cea"]])

export default __exports__